import { HeroUIProvider } from '@heroui/react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BezelProvider } from '@shared/components/Bezel';
import { ModalProvider } from '@shared/components/Modal';
import { ToastProvider } from '@shared/components/Toast';

const HERO_LOCALE: Record<string, string> = {
  es: 'es-MX',
  fr: 'fr-CA',
  en: 'en-US',
};

interface Props {
  children: ReactNode;
}

export function UIProvider({ children }: Props) {
  const { i18n } = useTranslation();
  const langCode = i18n.language?.split('-')[0] ?? 'en';
  const heroLocale = HERO_LOCALE[langCode] ?? 'en-US';

  return (
    <HeroUIProvider locale={heroLocale} style={{ display: 'contents' }}>
      <ModalProvider>
        <BezelProvider>
          <ToastProvider>{children}</ToastProvider>
        </BezelProvider>
      </ModalProvider>
    </HeroUIProvider>
  );
}
